// src/services/loading-service.ts
import { reactive, computed, readonly } from 'vue';

const state = reactive({
  loadingCount: 0,
});

// Define isLoading as a computed ref
const isLoadingRef = computed(() => state.loadingCount > 0);

export const loadingService = {
  startLoading() {
    state.loadingCount++;
  },
  stopLoading() {
    if (state.loadingCount > 0) {
      state.loadingCount--;
    }
  },
  // Export isLoading as a readonly computed ref
  isLoading: readonly(isLoadingRef),
};
